import Button from '@cobliteam/ui/components/Button';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Icon, { type IconNames } from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { cardColorClass, iconColorClass } from '../../helpers';
import useSearch from '../../hooks/useSearch';
import type { ColorKeys } from '../../types';

type CardHeaderProps = {
  icon: IconNames;
  color?: ColorKeys;
  title: ReactNode;
  subtitle?: ReactNode;
  link?: string;
  linkTooltip?: string;
};

const CardHeader = ({ icon, color, title, subtitle, link, linkTooltip }: CardHeaderProps) => {
  const { setIsOpen } = useSearch();

  return (
    <div className='flex justify-between gap-2'>
      <div className='flex items-start gap-2'>
        <div className={cn('rounded-md border bg-gray-4 p-3', cardColorClass(color), iconColorClass(color))}>
          <Icon name={icon} className='size-5' />
        </div>
        <div className='flex flex-col'>
          <div className='font-semibold text-base'>{title}</div>
          {subtitle ? <div className='flex items-center gap-1 text-xs'>{subtitle}</div> : null}
        </div>
      </div>
      {link && (
        <Link to={link} onClick={() => setIsOpen(false)}>
          <Tooltip content={linkTooltip}>
            <Button variant='outlined' size='sm' color='default' icon={<Icon name='square-arrow-out-up-right' />} />
          </Tooltip>
        </Link>
      )}
    </div>
  );
};

export default CardHeader;
